var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg42 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(0 3.4)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FED100",
  d: "M10.696 5.998c.504 0 .99.08 1.446.226l.123.044a9.24 9.24 0 0 0-1.935 4.929h-.532a6.17 6.17 0 0 0-3.521 1.096 4.698 4.698 0 0 1 4.419-6.295"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  y: 9.896,
  fill: "#FED100",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  x: 2.474,
  y: 3.923,
  fill: "#FED100",
  rx: 0.8,
  transform: "rotate(45 4.723 4.723)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.599,
  height: 4.498,
  x: 9.896,
  fill: "#FED100",
  rx: 0.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M19.581 4.2a7.79 7.79 0 0 1 6.435 3.399c-3.665.083-6.646 2.914-6.948 6.503h-.41c-2.632 0-4.764 2.124-4.764 4.744 0 1.257.49 2.398 1.29 3.247H9.798a4.698 4.698 0 0 1-.215-9.392l.215-.005h1.911l.116-1.374A7.785 7.785 0 0 1 19.58 4.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M26.18 9.097a5.64 5.64 0 0 1 5.317 3.739l.416 1.17 1.228-.19q.323-.051.656-.051c2.314 0 4.187 1.865 4.187 4.163s-1.873 4.164-4.187 4.164H18.658a3.255 3.255 0 0 1-3.265-3.246 3.255 3.255 0 0 1 3.265-3.245h1.788l.116-1.373c.243-2.889 2.68-5.131 5.617-5.131M17.493 29.789l2.474-1.4a.75.75 0 0 1 .75 1.3l-2.424 1.4 2.424 1.4a.75.75 0 0 1-.75 1.298l-2.474-1.4v2.85a.75.75 0 1 1-1.5 0v-2.85l-2.373 1.4a.75.75 0 0 1-.75-1.299l2.424-1.4-2.424-1.4a.75.75 0 0 1 .75-1.298l2.374 1.399v-2.75a.75.75 0 0 1 1.5 0zm11.696 0 2.474-1.4a.75.75 0 0 1 .75 1.3l-2.425 1.4 2.425 1.4a.75.75 0 0 1-.75 1.298l-2.474-1.4v2.85a.75.75 0 1 1-1.5 0v-2.85l-2.374 1.4a.75.75 0 0 1-.75-1.299l2.425-1.4-2.424-1.4a.75.75 0 0 1 .75-1.298l2.373 1.399v-2.75a.75.75 0 0 1 1.5 0z"
}))));
export { Svg42 as ReactComponent };